import { render, staticRenderFns } from "./DetailCard.vue?vue&type=template&id=8e50f994&scoped=true&"
import script from "./DetailCard.vue?vue&type=script&lang=js&"
export * from "./DetailCard.vue?vue&type=script&lang=js&"
import style0 from "./DetailCard.vue?vue&type=style&index=0&id=8e50f994&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e50f994",
  null
  
)

export default component.exports